import { render, staticRenderFns } from "./EmployeeOccupationSkills.vue?vue&type=template&id=40d44b2e&scoped=true"
import script from "./EmployeeOccupationSkills.vue?vue&type=script&lang=js"
export * from "./EmployeeOccupationSkills.vue?vue&type=script&lang=js"
import style0 from "./EmployeeOccupationSkills.vue?vue&type=style&index=0&id=40d44b2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d44b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d44b2e')) {
      api.createRecord('40d44b2e', component.options)
    } else {
      api.reload('40d44b2e', component.options)
    }
    module.hot.accept("./EmployeeOccupationSkills.vue?vue&type=template&id=40d44b2e&scoped=true", function () {
      api.rerender('40d44b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/career/EmployeeOccupationSkills.vue"
export default component.exports